import styled from "styled-components";
import { COLORS } from "../../styles/colors";
import { breakpoint } from "../../styles/constants";

export interface WxSelectorProps {
  label: string;
  selected?: boolean;
  onSelect: () => void;
}

const WxSelector = ({ label, selected = false, onSelect }: WxSelectorProps) => {
  return (
    <Container data-active={selected} onClick={onSelect}>
      <p>{label}</p>
    </Container>
  );
};

const Container = styled.div`
  border: 1px solid ${COLORS.white};
  background-color: var(--bg-color, transparent);
  padding: 1.25rem 0;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  font-size: 0.75rem;

  @media (min-width: ${breakpoint}) {
    font-size: 0.875rem;
  }

  p {
    color: var(--text-color, ${COLORS.white});
    font-weight: 900;
  }

  &[data-active="true"] {
    --bg-color: ${COLORS.white};
    --text-color: ${COLORS.black};
  }
`;

export default WxSelector;
